import {svg as $agntW$svg, LitElement as $agntW$LitElement} from "lit";
import {property as $agntW$property, state as $agntW$state, customElement as $agntW$customElement} from "lit/decorators.js";
import {ResizeController as $agntW$ResizeController} from "@lit-labs/observers/resize-controller.js";
import {guard as $agntW$guard} from "lit/directives/guard.js";
import {bisector as $agntW$bisector, extent as $agntW$extent} from "d3-array";
import {scaleLinear as $agntW$scaleLinear} from "d3-scale";
import {line as $agntW$line, area as $agntW$area} from "d3-shape";
import {axisBottom as $agntW$axisBottom, axisLeft as $agntW$axisLeft} from "d3-axis";
import {select as $agntW$select, pointer as $agntW$pointer} from "d3-selection";
import $agntW$simplifyjs from "simplify-js";











var $916babf1e6dc2c08$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $916babf1e6dc2c08$var$ElevationProfile = class ElevationProfile extends (0, $agntW$LitElement) {
    constructor(){
        super(...arguments);
        this.tolerance = 1;
        this.locale = navigator.language;
        this.lines = [];
        this.points = [];
        this.updateScale = (x, y, width, height)=>{};
        this.margin = {
            top: 20,
            right: 20,
            bottom: 20,
            left: 40
        };
        this.tickSize = {
            x: 100,
            y: 40
        };
        this.pointerEvents = true;
        this.pointer = {
            x: 0,
            y: 0
        };
        this.resizeController = new (0, $agntW$ResizeController)(this, {
            callback: ()=>[
                    this.offsetWidth,
                    this.offsetHeight
                ]
        });
        this.plotData = [];
        this.pointsData = [];
        this.scaleX = (0, $agntW$scaleLinear)();
        this.scaleY = (0, $agntW$scaleLinear)();
        this.bisectDistance = (0, $agntW$bisector)((point)=>point.x);
        this.line = (0, $agntW$line)().defined((point)=>!isNaN(point.y)).x((point)=>this.scaleX(point.x)).y((point)=>this.scaleY(point.y));
        this.area = (0, $agntW$area)().defined((point)=>!isNaN(point.y)).x((point)=>this.scaleX(point.x)).y1((point)=>this.scaleY(point.y));
        this.xAxis = (0, $agntW$axisBottom)(this.scaleX).tickFormat((value)=>this.tickFormat(value, "x"));
        this.yAxis = (0, $agntW$axisLeft)(this.scaleY).tickFormat((value)=>this.tickFormat(value, "y"));
        this.xGrid = (0, $agntW$axisBottom)(this.scaleX).tickFormat(()=>"");
        this.yGrid = (0, $agntW$axisLeft)(this.scaleY).tickFormat(()=>"");
        this.meterFormat = null;
        this.kilometerFormat = null;
    }
    updated(changedProperties) {
        if (changedProperties.has("locale")) {
            this.meterFormat = new Intl.NumberFormat(this.locale, {
                style: "unit",
                unit: "meter"
            });
            this.kilometerFormat = new Intl.NumberFormat(this.locale, {
                style: "unit",
                unit: "kilometer"
            });
        }
    }
    willUpdate(changedProperties) {
        if (changedProperties.has("lines")) {
            this.plotData.length = 0;
            for (const line of this.lines){
                const data = line.map((coordinate)=>({
                        x: coordinate[3],
                        y: coordinate[2],
                        coordinate: coordinate
                    }));
                this.plotData.push(...(0, $agntW$simplifyjs)(data, this.tolerance));
                this.plotData.push({
                    x: line[line.length - 1][3],
                    y: NaN,
                    coordinate: []
                });
            }
            this.scaleX.domain((0, $agntW$extent)(this.plotData, (data)=>data.x));
            this.scaleY.domain((0, $agntW$extent)(this.plotData, (data)=>data.y));
            this.updateScale(this.scaleX, this.scaleY, this.offsetWidth, this.offsetHeight);
        }
        if (changedProperties.has("points")) {
            this.pointsData.length = 0;
            for (const point of this.points)this.pointsData.push({
                x: point[3],
                y: point[2],
                coordinate: point
            });
        }
    }
    render() {
        const [width, height] = this.resizeController.value ?? [
            0,
            0
        ];
        this.scaleX.range([
            this.margin.left,
            width - this.margin.right
        ]);
        this.scaleY.range([
            height - this.margin.bottom,
            this.margin.top
        ]);
        this.area.y0(height - this.margin.bottom);
        this.yGrid.tickSize(-width + this.margin.left + this.margin.right);
        this.xGrid.tickSize(height - this.margin.top - this.margin.bottom);
        const xTicks = width / this.tickSize.x;
        const yTicks = height / this.tickSize.y;
        this.xAxis.ticks(xTicks);
        this.xGrid.ticks(xTicks);
        this.yAxis.ticks(yTicks);
        this.yGrid.ticks(yTicks);
        (0, $agntW$select)(this.querySelector(".axis.x")).call(this.xAxis);
        (0, $agntW$select)(this.querySelector(".axis.y")).call(this.yAxis);
        (0, $agntW$select)(this.querySelector(".grid.x")).call(this.xGrid);
        (0, $agntW$select)(this.querySelector(".grid.y")).call(this.yGrid);
        const offset = this.yGrid.offset();
        return (0, $agntW$svg)`
      <svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg">
        <g class="grid y" transform="translate(${this.margin.left}, 0)" />
        <g class="grid x" transform="translate(0, ${this.margin.bottom})" />
        <g class="axis x" transform="translate(0, ${height - this.margin.bottom})" />
        <g class="axis y" transform="translate(${this.margin.left}, 0)" />

        ${(0, $agntW$guard)([
            this.lines,
            width,
            height
        ], ()=>(0, $agntW$svg)`
          <path class="area" d="${this.area(this.plotData)}" />
          <path class="elevation" d="${this.line(this.plotData)}" fill="none" />`)}

        <g style="visibility: ${this.pointer.x > 0 ? "visible" : "hidden"}">
          <g clip-path="polygon(0 0, ${this.pointer.x - this.margin.left} 0, ${this.pointer.x - this.margin.left} 100%, 0 100%)">
            ${(0, $agntW$guard)([
            this.lines,
            width,
            height
        ], ()=>(0, $agntW$svg)`<path class="elevation highlight" d="${this.line(this.plotData)}" fill="none" />`)}
          </g>
          <line
            class="pointer-line x"
            x1="${this.pointer.x}"
            y1="${this.margin.top}"
            x2="${this.pointer.x}"
            y2="${height - this.margin.bottom}"
          />
          <line
            class="pointer-line y"
            x1="${this.margin.left}"
            y1="${this.pointer.y}"
            x2="${width - this.margin.right}"
            y2="${this.pointer.y}"
          />
          <circle class="pointer-circle-outline" cx="${this.pointer.x}" cy="${this.pointer.y}" r="16"/>
          <circle class="pointer-circle" cx="${this.pointer.x}" cy="${this.pointer.y}" r="6"/>
        </g>

        ${this.pointsData.map((point, index)=>this.pointSvg(this.scaleX(point.x), this.scaleY(point.y), index))}

        <rect
          width="${width}"
          height="${height}"
          fill="none"
          pointer-events="${this.pointerEvents ? "all" : "none"}"
          style="display: block; touch-action: none;"
          @pointermove="${this.pointerMove}"
          @pointerout="${this.pointerOut}"
        />
        <g
          transform="translate(${this.margin.left},${height - this.margin.bottom + offset})"
          class="axis"
          style="visibility: ${this.lines.length ? "visible" : "hidden"}">
          <line x2="${width - this.margin.left - this.margin.right}"></line>
        </g>
      </svg>
    `;
    }
    tickFormat(value, axis) {
        if (axis === "y" || value < 1000) return this.meterFormat.format(value);
        else return this.kilometerFormat.format(value / 1000);
    }
    tickValues(values, axis) {
        if (values.length === 0 || axis !== "x" && axis !== "y") return;
        axis === "x" ? this.xAxis.tickValues(values) : this.yAxis.tickValues(values);
    }
    pointSvg(x, y, index) {
        return (0, $agntW$svg)`<circle class="point" cx="${x}" cy="${y}" r="10"/>`;
    }
    firstUpdated() {
        // FIXME: because the ref element are used before render is done, we need to force an update
        this.requestUpdate();
    }
    pointerMove(event) {
        const pointerDistance = this.scaleX.invert((0, $agntW$pointer)(event)[0]);
        const index = Math.min(this.bisectDistance.left(this.plotData, pointerDistance), this.plotData.length - 1);
        if (index < 0) return;
        // FIXME:
        // var d0 = this.plotData[index - 1]
        // var d1 = this.plotData[index];
        // // work out which date value is closest to the mouse
        // var d = mouseDate - d0[0] > d1[0] - mouseDate ? d1 : d0;
        const data = this.plotData[index];
        if (isNaN(data.y)) return;
        this.pointer = {
            x: this.scaleX(data.x),
            y: this.scaleY(data.y)
        };
        this.dispatchEvent(new CustomEvent("over", {
            detail: {
                coordinate: this.plotData[index].coordinate,
                position: this.pointer
            }
        }));
    }
    pointerOut() {
        this.pointer = {
            x: 0,
            y: 0
        };
        this.dispatchEvent(new CustomEvent("out"));
    }
    createRenderRoot() {
        return this;
    }
};
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: Number
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "tolerance", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: String
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "locale", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: Array
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "lines", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: Array
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "points", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)()
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "updateScale", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: Object
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "margin", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: Object
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "tickSize", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$property)({
        type: Boolean
    })
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "pointerEvents", void 0);
$916babf1e6dc2c08$var$__decorate([
    (0, $agntW$state)()
], $916babf1e6dc2c08$var$ElevationProfile.prototype, "pointer", void 0);
$916babf1e6dc2c08$var$ElevationProfile = $916babf1e6dc2c08$var$__decorate([
    (0, $agntW$customElement)("elevation-profile")
], $916babf1e6dc2c08$var$ElevationProfile);
var $916babf1e6dc2c08$export$2e2bcd8739ae039 = $916babf1e6dc2c08$var$ElevationProfile;


export {$916babf1e6dc2c08$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=elevation-profile.js.map
